// A single requestAnimationFrame fires BEFORE the next paint; the nested one
// runs after it, so pending UI state gets painted before heavy sync work.
export function runAfterPaint(callback) {
  requestAnimationFrame(() => {
    requestAnimationFrame(callback)
  })
}
